import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAppstoreComponent } from './simple-icons-appstore.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAppstoreComponent ],
    exports:      [ SimpleIconsAppstoreComponent ],
    bootstrap:    []
})
export class SimpleIconsAppstoreModule {}
